'use client'
import { useContext } from 'react'
import { ThemeContext } from './components/theme'

const HippoMagic = () => {
    const { nextColorId } = useContext(ThemeContext)
    return (
        <img
            src={'/hippos/standing.svg'}
            alt="hippo"
            width={35}
            onClick={() => {
                nextColorId()
            }}
        />
    )
}
export default HippoMagic
